import React from "react";
import FilterTag from "./FilterTag";
import useStore from "../store/useStore";

const Filters = ({ className }) => {
  const availableCategoriesWithTags = useStore(
    (state) => state.availableCategoriesWithTags
  )();

  return (
    <div className={className}>
      {availableCategoriesWithTags.map((category) => (
        <div key={category.uid}>
          <div className="filters__category-headline">{category.name}</div>
          {category.tags.map((filter) => (
            <FilterTag filter={filter} key={filter.uid} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Filters;
